import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';

import { Link } from 'react-router-dom';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    activeItem: {
        borderLeftColor: theme.palette.secondary.main,
        borderLeftStyle: 'solid',
        borderLeftWidth: 3,
        color: theme.palette.primary.main,
    },
    icon: {
        color: 'inherit',
    },
    nested: {
        '&:hover': {
            borderLeftColor: theme.palette.secondary.main,
            borderLeftStyle: 'solid',
            borderLeftWidth: 3,
            color: theme.palette.primary.main,
            cursor: 'pointer',
        },
        '&$selected': {
            '&:hover': {
                borderLeftColor: theme.palette.secondary.main,
                borderLeftStyle: 'solid',
                borderLeftWidth: 3,
                color: theme.palette.primary.main,
                cursor: 'pointer',
            },
            borderLeftColor: theme.palette.secondary.main,
            borderLeftStyle: 'solid',
            borderLeftWidth: 3,
            color: theme.palette.primary.main,
        },
        paddingLeft: theme.spacing(4),
    },
    root: {
        '&:hover': {
            borderLeftColor: theme.palette.secondary.main,
            borderLeftStyle: 'solid',
            borderLeftWidth: 3,
            color: theme.palette.primary.main,
            cursor: 'pointer',
        },
        '&$selected': {
            '&:hover': {},
            borderLeftColor: theme.palette.secondary.main,
            borderLeftStyle: 'solid',
            borderLeftWidth: 3,
            color: theme.palette.primary.main,
        },
        backgroundColor: theme.palette.background.paper,
        maxWidth: 360,
        width: '100%',
    },
    selected: {},
}));

const CustomLink = ({ children, label, nested, route, selected, tooltip }: any) => {
    const classes = useStyles();
    return (
        <Link
            style={{
                color: 'inherit',
                textDecoration: 'none',
            }}
            to={route}
        >
            <Tooltip placement="left-start" title={`${tooltip}`}>
                <ListItem
                    button
                    className={clsx(nested ? classes.nested : '')}
                    classes={{ root: classes.root, selected: classes.selected }}
                    selected={selected}
                >
                    <ListItemIcon classes={{ root: classes.icon }}>{children}</ListItemIcon>
                    <ListItemText primary={`${label}`} />
                </ListItem>
            </Tooltip>
        </Link>
    );
};

export default CustomLink;
